import T from 'prop-types';
import React from 'react';

export const FixedRatioColoredBackground = ({ type = 'default', children }) => (
  <div className={`fixed-ratio-colored-background fixed-ratio-colored-background--${type}`}>
    <div className="fixed-ratio-colored-background__container">{children}</div>
  </div>
);

FixedRatioColoredBackground.propTypes = {
  type: T.oneOf(['info', 'warning', 'error']),
  children: T.element,
};

export default FixedRatioColoredBackground;
